import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  licensingAuthorityTitle: {
    defaultMessage: 'Licensing authority',
    id: '/Q8aMx',
    description: 'field title',
  },
  licensingAuthorityDesc: {
    defaultMessage: 'Learn more about license types <a>here</a>.',
    id: '1s5SCC',
    description: 'field description',
  },
  driverLicenseTitle: {
    defaultMessage: 'Private Hire Driver License Number',
    id: 'pFGlVW',
    description: 'PHD License Number field title',
  },
  driverLicenseDesc: {
    defaultMessage: 'Full PHD license number from your licensing authority.',
    id: 'NB/idy',
    description: 'input tip',
  },
  addressTitle: {
    defaultMessage: 'Home address',
    id: '4TxXBI',
    description: 'Field title for address input',
  },
});
